import { IListingClientSearchIntent } from "@tm/insurance/api";
import { getSessionStorageItem, setSessionStorageItem } from "@tm/utility";
import { MyCashState } from "./components/PlanCards/types";

// ──── Session Keys ────

const SESSION_KEYS = {
  AMT_ORIGINAL_PARAMS: "ins_listing_amt_original_params",
  MYCASH_STATE: "ins_listing_mycash_state",
  LANDING_SOURCE: "ins_listing_landing_source",
} as const;

// ──── AMT Original Params ────

export const getAmtOriginalParams = (): IListingClientSearchIntent | null =>
  getSessionStorageItem(SESSION_KEYS.AMT_ORIGINAL_PARAMS) ?? null;

export const setAmtOriginalParams = (params: IListingClientSearchIntent) => {
  setSessionStorageItem(SESSION_KEYS.AMT_ORIGINAL_PARAMS, params, true);
};

export const clearAmtSession = () => {
  setSessionStorageItem(SESSION_KEYS.AMT_ORIGINAL_PARAMS, null, true);
};

// ──── MyCash ────

const VALID_MYCASH_STATES = new Set<MyCashState>([
  "applied",
  "unApplied",
  "loggedOut",
]);

export const getMyCashState = (
  fallback: MyCashState = "loggedOut"
): MyCashState => {
  const stored = getSessionStorageItem(SESSION_KEYS.MYCASH_STATE);
  return VALID_MYCASH_STATES.has(stored) ? stored : fallback;
};

export const setMyCashSessionState = (state: MyCashState) => {
  setSessionStorageItem(SESSION_KEYS.MYCASH_STATE, state, true);
};

// ──── Landing Source ────

type LandingSource = "COMMON_LANDING" | "DIRECT";

export const getLandingSource = (): LandingSource | null =>
  getSessionStorageItem(SESSION_KEYS.LANDING_SOURCE) ?? null;

export const setLandingSource = (source: LandingSource) => {
  setSessionStorageItem(SESSION_KEYS.LANDING_SOURCE, source, true);
};
